import Parse from "parse";

export const GetPairingCodeInfoError = {
  failed: "failed",
  codeExpired: "code_expired",
  codeNotFound: "code_not_found"
};

export function generatePairingCode({ xmppLogin, deviceName }) {
  return Parse.Cloud.run("generatePairingCode", { xmppLogin, deviceName });
}

export function getPairingCodeInfo(code) {
  return Parse.Cloud.run("getPairingCodeInfo", { code });
}
